export default __webpack_public_path__ + "static/media/polygon-logo.8a29af74.svg";